module.exports = __webpack_public_path__ + "img/solicitud-ingresada-2.77e4a95c.png";